/* eslint-disable no-template-curly-in-string */
const defaultGameTemplate = [
  {
    type: 'NavigationMenu',
    props: null
  },
  {
    type: 'GameHero',
    props: null
  },
  {
    type: 'GameHeroTickerOverlay',
    props: null
  },
  {
    type: 'ZeroBanner',
    props: {
      ctaButtonText: 'Join Now'
    }
  },
  {
    type: 'Hypertext',
    props: null
  },
  {
    type: 'NavigationBreadcrumb',
    props: {
      showBreadcrumb: true
    }
  },
  {
    type: 'Introduction',
    props: null
  },
  {
    type: 'GameFeatures',
    props: null
  },
  {
    type: 'GameContent',
    props: null
  }
]

const defaultCallToAction = [
  {
    type: 'CallToAction',
    props: {
      text: 'Join Now',
      href: '/onboarding/register'
    }
  }]

const gamesRowTemplate = [
  {
    type: 'SubTitle',
    props: {
      title: "More games we think you'll like"
    }
  },
  {
    type: 'GameCarousel',
    props: {
      listId: 'PopularGamesToTry',
      query: {
        tags: [
          '404'
        ]
      }
    }
  }]

const ballyukTemplate = [
  {
    type: 'Spacer',
    props: { size: '35' }
  },
  {
    type: 'SubTitle',
    props: { title: 'More epic games worth playing' }
  },
  {
    type: 'GameCarousel',
    props: { listId: 'TopGames', query: { tags: 'priority-1', sort: 'added', limit: 5 } }
  },
  {
    type: 'Spacer',
    props: { size: '35' }
  },
  {
    type: 'Hypertext',
    props: null
  }
]

const esGameTemplate = [
  {
    type: 'ZeroBanner',
    props: { ctaButtonText: 'REGÍSTRATE' }
  },
  {
    type: 'CallToAction',
    props: { text: 'REGÍSTRATE', href: '/register' }
  }
]

const ballybetazTemplate = [
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://on.${baseUrl}/onboarding/register' }
  }
]

const ballycasinonjTemplate = [
  {
    type: 'GameHero',
    props: { enableStateModal: true }
  },
  {
    type: 'ZeroBanner',
    props: { ctaButtonText: 'Join Now', enableStateModal: true }
  },
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://play.ballybet.com/account/registration' }
  }
]

const ballybetcaTemplate = [
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://play.ballybet.ca/account/registration' }
  }
]

const rainbowrichescasinoTemplate = [
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://www.rainbowrichescasino.com/registration/account?chID=RRCSEO100FS50BINGO' }
  }
]

const monopolycasinoTemplate = [
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://play.monopolycasino.com/onboarding/register' }
  }
]

const monopolycasinocaTemplate = [
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://play.monopolycasinous.com/account/registration' }
  },
  {
    type: 'NavigationBreadcrumb',
    props: {
      showBreadcrumb: false
    }
  }
]

const monopolycasinousTemplate = [
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://play.monopolycasinous.com/account/registration' }
  },
  {
    type: 'NavigationBreadcrumb',
    props: {
      showBreadcrumb: false
    }
  }
]

const virgingamesTemplate = [

  {
    type: 'SubTitle',
    props: { title: 'More ${categoryName} you might like' }
  },
  {
    type: 'GameCarousel',
    props: { listId: 'TopGames', query: { categoryId: '${categoryId}', sort: 'order', limit: 4 } }
  },
  {
    type: 'Spacer',
    props: { size: '35' }
  },
  {
    type: 'CallToAction',
    props: { text: 'Join Now', href: 'https://www.virgingames.com/registration/account' }
  }
]

const overrideTemplateProps = (templates) => {
  let components = []

  templates.forEach(element => {
    if (components.length === 0) {
      components = [...element]
    } else {
      element.forEach(component => {
        const existingComponent = components.findIndex(el => el.type === component.type)

        if (existingComponent !== -1) {
          components[existingComponent].props = component.props
        } else {
          components = [...components, component]
        }
      })
    }
  })

  return components
}

export const handleGameTemplate = (venture) => {
  switch (venture) {
    case 'monopolycasino':
      return [...defaultGameTemplate, ...monopolycasinoTemplate]
    case 'jackpotjoy':
      return [...defaultGameTemplate, ...defaultCallToAction, ...gamesRowTemplate]
    case 'botemania_es':
    case 'monopolycasino_es':
      return overrideTemplateProps([defaultGameTemplate, defaultCallToAction, esGameTemplate])
    case 'ballybetaz':
      return [...defaultGameTemplate, ...ballybetazTemplate]
    case 'ballyuk':
      return [...defaultGameTemplate, ...defaultCallToAction, ...ballyukTemplate]
    case 'ballycasinonj':
      return overrideTemplateProps([defaultGameTemplate, defaultCallToAction, ballycasinonjTemplate])
    case 'ballybetca':
      return [...defaultGameTemplate, ...ballybetcaTemplate]
    case 'rainbowrichescasino':
      return [...defaultGameTemplate, ...rainbowrichescasinoTemplate]
    case 'monopolycasinous':
      return overrideTemplateProps([defaultGameTemplate, monopolycasinousTemplate])
    case 'monopolycasinoca':
      return overrideTemplateProps([defaultGameTemplate, monopolycasinocaTemplate])
    case 'doublebubblebingo':
      return [
        ...defaultGameTemplate,
        ...defaultCallToAction,
        ...gamesRowTemplate
      ]
    case 'virgingames':
      return [
        ...defaultGameTemplate,
        ...virgingamesTemplate
      ]
    case 'ballycasinogr':
      return [...defaultGameTemplate, ...defaultCallToAction, ...ballyukTemplate]
    default:
      return [
        ...defaultGameTemplate,
        ...defaultCallToAction
      ]
  }
}
